import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserBoxComponent } from "@the-guild-llc/gatekeeper-dev";

@Component({
    selector: 'app-root',
    standalone: true,
  imports: [RouterOutlet, UserBoxComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

}
